(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flex-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('flex-collection-tabs')) {
    customElements.define('flex-collection-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.waitForContent = () => {
          if (!this.isConnected || this.initialized) return;

          const tabs = Array.from(this.querySelectorAll('.fct-tab'));
          const contentReady = tabs.length && tabs.every(tab => {
            return this.querySelector(
              '#' + CSS.escape(tab.getAttribute('aria-controls'))
            );
          });

          if (!contentReady) return;

          this.observer?.disconnect();
          this.initialized = true;
          this.tabs = tabs;
          this.panels = Array.from(this.querySelectorAll('.fct-panel'));
          this.shopAll = this.querySelector('.fct-shop-all');

          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.activate(index));

            tab.addEventListener('keydown', event => {
              let next = index;

              if (event.key === 'ArrowRight') {
                next = (index + 1) % this.tabs.length;
              } else if (event.key === 'ArrowLeft') {
                next = (index - 1 + this.tabs.length) % this.tabs.length;
              } else if (event.key === 'Home') {
                next = 0;
              } else if (event.key === 'End') {
                next = this.tabs.length - 1;
              } else {
                return;
              }

              event.preventDefault();
              this.activate(next);
              this.tabs[next].focus({ preventScroll: true });
              this.tabs[next].scrollIntoView({
                block: 'nearest',
                inline: 'nearest'
              });
            });
          });

          this.addEventListener('click', event => {
            const sizeButton = event.target.closest('button.fct-size');
            if (sizeButton && this.contains(sizeButton)) {
              this.addSizeToCart(sizeButton);
            }
          });

          this.addEventListener('shopify:block:select', event => {
            const index = this.tabs.findIndex(tab => {
              return tab.dataset.block === event.detail.blockId;
            });

            if (index >= 0) this.activate(index);
          });

          this.activate(0);
        };

        this.observer = new MutationObserver(this.waitForContent);
        this.observer.observe(this, {
          childList: true,
          subtree: true
        });

        this.waitForContent();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      activate(index) {
        const activeTab = this.tabs[index];
        if (!activeTab) return;

        const panelId = activeTab.getAttribute('aria-controls');

        this.tabs.forEach((tab, i) => {
          const selected = i === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });

        this.panels.forEach(panel => {
          panel.hidden = panel.id !== panelId;
        });

        const panel = this.panels.find(item => item.id === panelId);
        const url = panel?.dataset.url;

        if (this.shopAll) {
          this.shopAll.hidden = !url;
          if (url) this.shopAll.href = url;
        }
      }

      async addSizeToCart(button) {
        if (button.disabled) return;

        const root = window.Shopify?.routes?.root || '/';
        const originalText = button.textContent;
        button.disabled = true;

        try {
          const addResponse = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: Number(button.dataset.variantId),
                quantity: 1
              }]
            })
          });

          const result = await addResponse.json();

          if (!addResponse.ok) {
            throw new Error(
              result.description ||
              result.message ||
              'Could not add this size.'
            );
          }

          const cartResponse = await fetch(root + 'cart.js', {
            headers: { 'Accept': 'application/json' }
          });

          if (!cartResponse.ok) {
            throw new Error('Could not update the cart number.');
          }

          const cart = await cartResponse.json();

          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              data: {
                itemCount: cart.item_count,
                source: 'product-form-component'
              }
            }
          }));

          const cartIcon = document.querySelector('cart-icon');
          const bubble = cartIcon?.querySelector('[ref="cartBubble"]');
          const count = cartIcon?.querySelector('[ref="cartBubbleCount"]');

          if (count) {
            count.textContent = cart.item_count;
            count.classList.toggle('hidden', cart.item_count === 0);
          }

          if (bubble) {
            bubble.classList.toggle('visually-hidden', cart.item_count === 0);
          }

          button.textContent = '✓';
          setTimeout(() => {
            if (button.isConnected) button.textContent = originalText;
          }, 1200);
        } catch (error) {
          button.textContent = 'Error';
          button.title = error.message || 'Could not add this size.';

          setTimeout(() => {
            if (button.isConnected) button.textContent = originalText;
          }, 1800);
        } finally {
          button.disabled = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
